
import React, { useEffect, useState, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

function CurrencyCard({ currency, onClick }) {
  return (
    <div className="crypto-card" onClick={() => onClick(currency.id)}>
      {/* Si une image est disponible, l'afficher ici comme pour les cryptos */}
      {/* <img src={currency.imgUrl} alt={currency.name} className="crypto-img" /> */}
      <div className="crypto-info">
        <div className="crypto-code">{currency.code}</div>
        <div className="crypto-name">{currency.name}</div>
        <div className="crypto-price">
          {currency.conversionRate !== undefined && currency.conversionRate !== null
            ? `1 USD = ${currency.conversionRate} ${currency.code}`
            : <span style={{ color: '#aaa' }}>Taux inconnu</span>}
        </div>
      </div>
    </div>
  );
}

const PAGE_SIZE = 20;

export default function CurrencyList() {
  const [currencies, setCurrencies] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const loader = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    fetch('/api/currencies')
      .then(res => res.json())
      .then(data => {
        setCurrencies(data);
        setFiltered(data);
        setHasMore(data.length > PAGE_SIZE);
      });
  }, []);

  useEffect(() => {
    const f = currencies.filter(c =>
      c.name.toLowerCase().includes(search.toLowerCase()) ||
      c.code.toLowerCase().includes(search.toLowerCase())
    );
    setFiltered(f);
    setPage(1);
    setHasMore(f.length > PAGE_SIZE);
  }, [search, currencies]);

  const displayed = filtered.slice(0, page * PAGE_SIZE);

  const handleScroll = useCallback(() => {
    if (!hasMore) return;
    if (loader.current) {
      const rect = loader.current.getBoundingClientRect();
      if (rect.top < window.innerHeight) {
        setPage(p => {
          const next = p + 1;
          setHasMore(filtered.length > next * PAGE_SIZE);
          return next;
        });
      }
    }
  }, [hasMore, filtered.length]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <div className="crypto-list-page">
      <h2>Currencies</h2>
      <input
        type="text"
        placeholder="Search by code or name..."
        value={search}
        onChange={e => setSearch(e.target.value)}
        className="crypto-search"
      />
      <div className="crypto-grid">
        {displayed.map(currency => (
          <CurrencyCard key={currency.id} currency={currency} onClick={id => navigate(`/currencies/${id}`)} />
        ))}
      </div>
      {hasMore && <div ref={loader} style={{ height: 40 }} />}
      {!hasMore && displayed.length === 0 && <div>No currencies found.</div>}
    </div>
  );
}
